import { createSelector } from '@reduxjs/toolkit';
import { VERSION } from '../../utils/version.js';
export const getAnalyticsSource = createSelector((state) => state.source, (source) => Object.entries(source)
    .map(([frameworkName, frameworkVersion]) => `${frameworkName}@${frameworkVersion}`)
    .concat(`@coveo/headless@${VERSION}`));
